import { selectCurrentRoles } from "features/auth/authSlice";
import { useState } from "react";
import Lightbox from "react-awesome-lightbox";
import "react-awesome-lightbox/build/style.css";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Card, CardBody, Col, Modal, Row, Spinner } from "reactstrap";
import swal from "sweetalert";
import img1 from "../../assets/images/default.jpg";
import pdfimg from "../../assets/images/pdf-img.jpg";
import {
  useGetSathiDetailsbyIdQuery,
  useRegenerateSaathiFormQuery,
} from "./SaathiApiSlice";

import SaathiUploadAgreement from "./SaathiUploadAgreement";

const SaathiDocuments = ({ SaathiUserData }) => {
  const [isEffects, setisEffects] = useState(false);
  const RolesFromToken = useSelector(selectCurrentRoles);

  const { id } = useParams();

  const [showPdf, setPdf] = useState();
  const [Saathipdf, setSaathipdf] = useState(false);
  const [loader, setLoader] = useState(false);
  const [regenerateUrl, setRegenerateUrl] = useState("");
  const [genratedurl, setgenratedurl] = useState(false);
  const [showFinalimage, setShowFinalImage] = useState({});
  const agreed =
    SaathiUserData !== undefined ? SaathiUserData.is_agreed : "false";

  const Saathipdf_edit = (index) => {
    setSaathipdf(!Saathipdf);
    setSaathipdf((prevSaathipdf) => ({
      [index]: !prevSaathipdf[index],
    }));
  };

  const {
    data: data,
    refetch: SaathiDetailsRefetch,
  } = useGetSathiDetailsbyIdQuery(id);

  const genrateAgreementForm = () => {
    setLoader(true)
      .unwrap()
      .then((res) => {
        if (res.status === 200) {
          swal("Success", {
            buttons: false,
            icon: "success",
            title: "Agreement Generated",
            timer: 1000,
          });
          setLoader(false);
          setgenratedurl(true);
          setRegenerateUrl(res?.data?.empanelment_form_url);
        } else {
          swal("Error", res.message, "error");
          setLoader(false);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  return (
    <Row>
      {SaathiUserData?.all_media?.length > 0 ? (
        <Col lg={10} className="mb-2">
          <div className="popup-gallery d-flex flex-wrap">
            {SaathiUserData !== undefined && SaathiUserData.all_media !== null
              ? SaathiUserData.all_media &&
                SaathiUserData.all_media.map((list, index) =>
                  list.file !== "object" ? (
                    list.file_extension === ".png" ||
                    list.file_extension === ".jpeg" ||
                    list.file_extension === ".jpg" ? (
                      <Col lg={2} key={index}>
                        <Card className="text-center border ">
                          <CardBody style={{ padding: "1rem" }}>
                            <div className="img-fluid float-left">
                              <small className="mb-1 text-uppercase">
                                {list.document_type ===
                                "Police Verification Certificate"
                                  ? "Police Certificate"
                                  : list.document_type}
                              </small>
                              <hr className="mt-2" />

                              {list.filename === null ||
                              list.filename === undefined ||
                              list.filename.length === 0 ? (
                                "No Image Found"
                              ) : (
                                <img
                                  src={img1}
                                  onClick={(e) => {
                                    setisEffects(true);
                                    setShowFinalImage(list.filename);
                                  }}
                                  className="img-fluid"
                                />
                              )}
                            </div>
                          </CardBody>
                        </Card>
                      </Col>
                    ) : (
                      <Col lg={2} key={index}>
                        <Card className="text-center border ">
                          <CardBody style={{ padding: "1rem" }}>
                            <div className="img-fluid float-left">
                              <small className="mb-1 text-uppercase">
                                {list.document_type}
                              </small>
                              <hr className="mt-2" />
                              <img
                                src={pdfimg}
                                style={{ width: "53%" }}
                                aria-controls="userDetails"
                                data-toggle="modal"
                                data-target="#userDetails"
                                onClick={(e) => {
                                  setSaathipdf(true);
                                  setPdf(list.filename);
                                }}
                                className=""
                              />
                            </div>
                          </CardBody>
                        </Card>
                      </Col>
                    )
                  ) : (
                    "NO Document Uploaded Yet"
                  )
                )
              : null}
          </div>
        </Col>
      ) : (
        <Col>
          <h4>No Documents Uploaded yet</h4>
        </Col>
      )}

      {SaathiUserData?.is_agreed === true ? (
        <>
          <Col lg={2}>
            <Card className="text-center border ">
              <CardBody className="p-4">
                <div className="img-fluid float-left">
                  <button
                    className="btn btn-primary text-white p-2"
                    onClick={genrateAgreementForm}
                  >
                    Re-generate Agreement &nbsp;
                    {loader ? (
                      <Spinner animation="border" size="sm"></Spinner>
                    ) : (
                      ""
                    )}
                  </button>

                  {genratedurl == true ? (
                    <>
                      <hr className="mt-2" />
                      <a
                        href={regenerateUrl}
                        className="img-fluid text-decoration-none text-primary"
                      >
                        Download <span className="mdi mdi-download"></span>
                      </a>
                    </>
                  ) : null}
                </div>
              </CardBody>
            </Card>
            {SaathiUserData.is_attached_by_agent === true ? (
              <Card className="text-center border ">
                <CardBody className="p-3">
                  <div className="img-fluid float-left">
                    <small className="mb-1 text-uppercase">Agreed Doc</small>

                    <hr className="mt-2" />
                    <a
                      href={SaathiUserData.attached_form_link}
                      target="_black"
                      className="img-fluid text-decoration-none text-primary"
                    >
                      Signed Agreement{" "}
                      <span className="mdi mdi-download"></span>
                    </a>
                  </div>
                </CardBody>
              </Card>
            ) : null}
          </Col>
        </>
      ) : null}

      {agreed == true &&
      SaathiUserData?.is_attached_by_agent == false &&
      RolesFromToken.groups?.includes("Maker") ? (
        <Row className="mb-3">
          <SaathiUploadAgreement
            SaathiUserData={SaathiUserData}
            refetch={SaathiDetailsRefetch}
          />
        </Row>
      ) : (
        ""
      )}

      {SaathiUserData?.is_agreed !== true &&
      RolesFromToken.groups?.includes("Maker") ? (
        <>
          {/* <Col lg={12}>
          <Card className="text-center border ">
            <CardBody className="p-4">
            
              <SaathiAgreement />
            </CardBody>
          </Card>
        </Col> */}
          <h6> *** Terms and Conditions is pending</h6>
        </>
      ) : null}
      {isEffects ? (
        <Lightbox
          image={showFinalimage}
          onClose={() => {
            setisEffects(!isEffects);
          }}
        />
      ) : null}

      {/* Model for pdf */}
      <Modal
        size="xl"
        isOpen={Saathipdf}
        toggle={() => {
          Saathipdf_edit();
        }}
      >
        <div className="modal-header bg-warning">
          <h5 className="modal-title " id="">
            Documents
          </h5>
          <button
            type="button"
            onClick={(e) => {
              setSaathipdf(false);
            }}
            style={{ borderRadius: "5px" }}
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <iframe
            src={showPdf !== undefined ? showPdf : pdfimg}
            width="100%"
            height="520"
          ></iframe>
        </div>
      </Modal>
    </Row>
  );
};

export default SaathiDocuments;
